import { FC, PropsWithChildren } from 'react';

import styles from 'components/common/DiscountedPrice/DiscountedPrice.module.less';

export const DiscountedPrice: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className={styles.discountWrapper}>
            {children}
            <div className={styles.lineThrough} />
        </div>
    );
};
